import React from 'react'

var EventFormSummary = React.createClass({
  // propTypes: {
  //   fields: React.PropTypes.array
  // },
  render: function() {
    const { onChange, fields } = this.props;
    return(
      <div className="panel">
        <div className="panel-heading">
          <div className="panel-title"> <span className="glyphicons glyphicons-ok_2"></span> Order Summary </div>
        </div>
        <div className="panel-body">
          <div className="form-group">
            <label className="col-lg-2 control-label">Name on Credit Card</label>
            <div className="col-lg-10">
              <input type="text" className="form-control" />
            </div>
          </div>
          <div className="form-group">
            <label className="col-lg-2 control-label">Credit Card Number</label>
            <div className="col-lg-10">
              <input type="text" className="form-control" />
            </div>
          </div>
          <div className="form-group">
            <label className="col-lg-2 control-label">Credit Card Expiry</label>
            <div className="col-lg-4">
              <div className="input-group col-sm-8">
                <input type="text" id="card_exp_month" className="form-control" placeholder="MM" data-stripe="exp-month" maxLength="2" required />
                <span className="input-group-addon">/</span>
                <input type="text" id="card_exp_year" className="form-control" placeholder="YYYY" maxLength="4" required />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="col-lg-2 control-label">Credit Card CVC</label>
            <div className="col-lg-2">
              <input type="text" className="form-control" />
            </div>
          </div>
        </div>
      </div>
    );
  }
});

export default EventFormSummary;


// WEBPACK FOOTER //
// ./src/components/event_form_summary.js